
const workerCode = () => {
    onmessage = (event) => {
        const { dockerName, dnsName, instanceId } = event.data;

        const eventSource = new EventSource(`${dnsName}/specific/docker/stream/?docker_name=${dockerName}&instance_id=${instanceId}`);
        eventSource.onmessage = function(event) {
            const data = JSON.parse(event.data);
            postMessage(data);
        }

        eventSource.onerror = function(error) {
            console.error("EventSource failed", error);
        };
    };
};

let code = workerCode.toString();
code = code.substring(code.indexOf("{") + 1, code.lastIndexOf("}"));

const blob = new Blob([code], { type: "application/javascript" });
const workerScript = URL.createObjectURL(blob);

module.exports = workerScript;